import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@material-ui/core/styles";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getDippingBatchHistoryDetails } from "./services";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    paddingBottom: "100px",
    minHeight: "85vh",
    minWidth: "95%",
    color: "#3C4856",
    fontSize: "16px",
  },
}));
const SelectBatch = () => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectBatchData, setSelectBatchData] = useState([]);
  const initiallValue = {
    B_No: "",
    UID: "",
    Lot_No: "",
    Class: "",
    Size: "",
    Scre: "",
    currentbatch: "",
  };
  const [searchText, setSearchText] = useState(initiallValue);
  const [debouncedSearch, setDebouncedSearch] = useState(searchText);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchText); 
    }, 500); 
    return () => {
      clearTimeout(handler); 
    };
  }, [searchText]);

  useEffect(() => {
    handleBatchData();
  }, [page, rowsPerPage, debouncedSearch]);

  const handleBatchData = async () => {
    const searchParams = {
      search: debouncedSearch,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    try {
      const resp = await getDippingBatchHistoryDetails(searchParams);
      if (resp.status == 200 || resp.status == 201) {
        setSelectBatchData(resp.data);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchData = async (e) => {
    // Destructure the name and value of the input field that triggered the change
    const { name, value } = e.target;

    console.log(`name:${e.target.name}....values:${e.target.value}`);

    // Update the searchText state object with the new value for the specified input field
    setSearchText({ ...searchText, [name]: value });
  };

  const navigate = useNavigate();
  return (
    <>
      <div className="page-wraper">
        <div className="page-header">
          <Link
            to="/production-line"
            className="page-back-btn"
            //   onClick={handleBack}
          >
            <ArrowBackIcon />
            <span style={{ width: "max-content" }}>SELECT BATCH NO</span>
          </Link>
        </div>
        <Table
          aria-label="Dipping parameter"
          className="dipping-params selectBatchTable"
        >
          <TableHead classes={{ root: classes.thead }}>
            <TableRow>
              <TableCell>B.No</TableCell>
              <TableCell>UID</TableCell>
              <TableCell>LOT No</TableCell>
              <TableCell>Class</TableCell>
              <TableCell>Size</TableCell>
              <TableCell>SC/RE</TableCell>
              <TableCell>Current Location</TableCell>
            </TableRow>

            <TableRow>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="B.No"
                  name="B_No"
                  value={searchText.B_No}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="UID"
                  name="UID"
                  value={searchText.UID}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="LOT No"
                  name="Lot_No"
                  value={searchText.Lot_No}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Class"
                  name="Class"
                  value={searchText.Class}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Size"
                  name="Size"
                  value={searchText.Size}
                  onChange={handleSearchData}
                />
              </TableCell>

              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />

                <select
                  name="Scre"
                  className="search-dropdown-left"
                  value={searchText.Scre}
                  onChange={handleSearchData}
                >
                  <option value="">All</option>
                  <option value="S.C.">S.C.</option>
                  <option value="R.E.">R.E.</option>
                </select>
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Location"
                  name="currentbatch"
                  value={searchText.currentbatch}
                  onChange={handleSearchData}
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectBatchData?.results?.map((row) => {
              console.log("rowsdfds", row.status);
              return (
                <TableRow
                  onClick={() =>
                    navigate("/production-line-chart", {
                      state: { batch_types: row.batchid, autoBatchSelect : true,batchTypeData: row.batch_type, },
                    })
                  }
                  style={{ cursor: "pointer" }}
                >
                  <TableCell style={{ color: "#1c407a", fontWeight: 700 }}>
                    {row.batch_type}
                  </TableCell>
                  <TableCell>
                    {" "}
                    {row.batch_id?.length > 0
                      ? `${row.batch_id[0].uid_id_type} - ${
                          row.batch_id[row.batch_id.length - 1].uid_id_type
                        }`
                      : "-"}
                  </TableCell>
                  <TableCell>{row.lot_number}</TableCell>
                  <TableCell>{row.class_name}</TableCell>
                  <TableCell>{row.size_name}</TableCell>
                  <TableCell>{row.scre}</TableCell>
                  <TableCell>{row.current_batch_station}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={selectBatchData ? selectBatchData.count : null}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
};

export default SelectBatch;
